<template>
  <section class="relative z-1">
    <img
      :src="JumbotronBannerImage"
      alt="Banner"
      class="absolute inset-0 w-full h-full object-cover -z-10"
      width="1920"
      height="1080"
    />

    <div
      class="px-4 mx-auto max-w-screen-xl text-center flex flex-col items-center justify-center py-24 lg:py-56 text-white"
    >
      <img
        src="/media/logos/logo_squared.webp"
        alt="Circus Logo"
        width="256"
        height="256"
      />

      <h1
        class="mb-4 text-4xl font-extrabold tracking-tight leading-none md:text-5xl lg:text-6xl"
      >
        <p>Herzlich Willkommen</p>
        <p class="text-4xl">zum</p>
        <p>Circus St.&nbsp;Ottilien 2025!</p>
      </h1>

      <ClientOnly v-if="!isExpired">
        <div class="grid grid-cols-4 gap-4">
          <div
            v-for="(value, unit) in timeLeft"
            :key="unit"
            class="text-center"
          >
            <div class="lg:text-5xl text-2xl font-bold mb-2">{{ value }}</div>
            <div class="text-xl uppercase md:block hidden">{{ unit }}</div>
            <div class="text-xl uppercase md:hidden">
              {{ unit.slice(0, 1) }}
            </div>
          </div>
        </div>
      </ClientOnly>

      <div v-else class="text-3xl font-bold text-center">
        Der Circus hat begonnen! 🎉
      </div>

      <a
        class="button flex items-center justify-center mx-auto gap-2 mt-8"
        download
        href="/download/Circus-St-Ottilien_Plakat_A2_V1_Anschnitt_Final.pdf"
        data-umami-event="program_downloaded"
      >
        <DownloadCloudIcon class="w-5 h-5" />
        <span> Programm herunterladen </span>
      </a>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { DownloadCloudIcon } from "lucide-vue-next";
import JumbotronBannerImage from "@/assets/images/jumbotron-banner.jpg";

const { timeLeft, isExpired } = useCountdown("2025-07-18T18:00:00+01:00");

const currentContent = ref(0);
const isTransitioning = ref(false);

const contentList = [
  "WICHTIG: Ohne Reservierung können Karten ab 1 Stunde vor Vorstellungsbeginn an der Kasse erworben werden. Verfügbarkeit nicht garantiert – frühes Erscheinen empfohlen!",
  "NEU: Online-Reservierung jetzt verfügbar! Sichern Sie sich Ihre Plätze bequem von zu Hause aus.",
  "TIPP: Folgen Sie uns auf Social Media für die neuesten Updates und Backstage-Einblicke!",
];

const changeContent = () => {
  isTransitioning.value = true;
  setTimeout(() => {
    currentContent.value = (currentContent.value + 1) % contentList.length;
    isTransitioning.value = false;
  }, 500);
};

onMounted(() => {
  setInterval(changeContent, 5000);
});
</script>
